import React, { useEffect, useState } from 'react';
import DoctorNotesFullMob from './DoctorNotesFullMobileView';


export default function DoctorNotesfull({ show, data, setclose }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize(); // run on mount
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!show) return null;
  function DataRender(){
    return(
     <pre className="baseText text-navLink whitespace-pre-wrap break-words w-full p-4 bg-lightBlue rounded-lg text-sm leading-relaxed overflow-y-auto">
       {data}
    </pre>
    )
  }
  return isMobile ? (
    <DoctorNotesFullMob
    closeFunction={()=>{setclose(false);console.log("close fun call")}}
    data={<DataRender />}
    />
  ) : (
    <div
      className="fixed top-0 left-0 w-full h-full bg-black/25 z-[1000] flex justify-center items-center px-4 pb-6"
      onClick={()=>{setclose(false);}}
    >
      <div
        className="bg-white w-full max-w-[60vw] max-h-[90vh] overflow-y-auto p-5 md:p-6 rounded-3xl shadow-lg space-y-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className='flex justify-between items-center flex-row'>
           <p className="text-lg font-medium text-coalBlack xl:text-xl mb-2">
          Doctor Notes
        </p>
         <p
            className="text-gray-500 text-sm font-medium min-w-10 p-2 cursor-pointer hidden xl:block ms-auto  -mt-[10px]"
            onClick={()=>{setclose(false);}}
          >
            close
          </p>
        </div>
       
        <DataRender />
      </div>
    </div>
  );
}
